import React, { useState } from 'react';
import { Grid, TextField, Button, Box, Typography } from '@mui/material';
import SearchService from '../../services/search.services';
import styles from './DuplicateDocument.module.css';


const OneDocument = () => {
  const [baseinput, setbaseInput] = useState('');
  const [compareinput, setcompareInput] = useState('');
  const [percentagediff, setPercentagediff] = useState(0);
  const [bvalid, setbValid] = useState(false);
  
  const handleSubmit = () => {
    setbValid(compareinput.length === baseinput.length);
    if (compareinput.length !== baseinput.length) {
      console.log("MUST BE SAME SIZE")
      return;
    }
    const diff = (SearchService.gethashDiffPercentageBinary(baseinput, compareinput));
    setPercentagediff(diff)
  };
  
  const handleInputChange2 = (event) => {
    const value = event.target.value;
    setcompareInput(value);
    setbValid(value.length === baseinput.length);
    setPercentagediff(0);
  };
  
  const handleInputChange = (event) => {
    const value = event.target.value;
    setbaseInput(value);
    setPercentagediff(0);
    setbValid(value.length === compareinput.length);
  };

  return (
    <div className={styles.container}>
      
      <Box className={styles.inputSection}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Base charikarLSH"
              variant="outlined"
              value={baseinput}
              onChange={handleInputChange}
              placeholder="Enter base hash value"
              helperText={baseinput ? `Length: ${baseinput.length}` : ''}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Compare charikarLSH"
              variant="outlined"
              value={compareinput}
              onChange={handleInputChange2}
              placeholder="Enter comparison hash value"
              helperText={compareinput ? `Length: ${compareinput.length}` : ''}
              error={compareinput && baseinput && compareinput.length !== baseinput.length}
            />
          </Grid>
        </Grid>

        <Typography className={styles.helpText}>
          ℹ️ Both hash values must be the same length to compute the Hamming distance
        </Typography>
      </Box>

      <Box className={styles.buttonContainer}>
        <Button
          variant="contained"
          disabled={!bvalid}
          onClick={handleSubmit}
          className={styles.computeButton}
          size="large"
        >
          Compute Hamming Distance
        </Button>
        {!bvalid && baseinput && compareinput && (
          <Typography color="error" variant="body2">
            Hash lengths don't match ({baseinput.length} vs {compareinput.length})
          </Typography>
        )}
      </Box>

      {percentagediff !== 0 && (
        <Box className={styles.resultContainer}>
          <Typography className={styles.resultTitle}>
            Document Match Result
          </Typography>
          
          <hr className={styles.divider} />
          
          <div>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Similarity Score:
            </Typography>
            <div className={`${styles.percentageBadge} ${percentagediff > 60 ? styles.percentageHigh : styles.percentageLow}`}>
              {percentagediff}%
            </div>
          </div>

          <Typography 
            className={`${styles.resultText} ${percentagediff > 60 ? styles.resultTextDuplicate : styles.resultTextNotDuplicate}`}
          >
            {percentagediff > 60 
              ? '✓ These documents should be considered Duplicates' 
              : '✗ These documents should NOT be considered Duplicates'}
          </Typography>
        </Box>
      )}
    </div>
  )
};

export default OneDocument;
